<template>
    <div class="course">
        <TopMenu></TopMenu>
        <!--<div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
            <div class="swiper-slide" :key="banner" v-for="banner in banners">
                <img :src="banner">
            </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>-->
        <swiper :options="swiperOption">
            <swiper-slide v-for="slide in swiperSlides" v-bind:key="slide.id">
                <a :href="slide.link"><img :src="slide.img" width="100%"></a>
                <div class="swiper-title">{{slide.title}}</div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="foreword">
            <div><img src="../../../assets/images/ydk_qianyan.jpg" width="90px"></div>
            <div class="text">
                <p>“德行天下·微影故事”——广西践行社会主义核心价值观主题微电影征集展示活动，是由自治区党委宣传部、自治区直属机关工委、自治区党委网信办、自治区党委教育工委、自治区广播电视局联合主办。活动主要通过创作微电影的方式，充分反映我区干部群众自觉践行社会主义核心价值观的生动实践，为谱写新时代广西发展新篇章凝聚强大正能量。</p>

                <p>2020年是全面建成小康社会目标实现之年，是全面打赢脱贫攻坚战收官之年。广西新闻网独家策划推出“德行天下·微影云党课”，以广西各地脱贫攻坚实践为大背景，让21部“德行天下·微影故事”获奖影片走进奋斗在脱贫攻坚一线的一些优秀村党支部，努力克服新冠肺炎疫情的影响，通过别开生面的“云党课”形式，在广西新闻网壮观客户端进行云端直播，传递社会主义核心价值观，解码广西乡村脱贫攻坚关键,彰显基层党组织负重笃行的责任担当。</p> 
            </div>
            <div class="showmore"  @click="showmore()"><span><img src="../../../assets/images/ydk_openmore.jpg" height="20px"></span></div>
        </div>
        <YNav></YNav>
        <div class="page_ad">
            <a href="http://sub.gxnews.com.cn/subject/2019/2019dxtx/">
                <img src="../../../assets/images/yundangke_banner_g.jpg" width="100%">
            </a>
        </div>
        <div class="news">
            <div class="ntitle"><span></span>“云党课”新闻聚焦<div class="rightmore"><a href="#/yundangkelist/新闻聚焦/143">查看更多&raquo;</a></div></div>
            <ul v-for="slide in swiperSlides" v-bind:key="slide.id">
                <li><a :href="slide.link">{{slide.title}}<br><span>{{slide.time}}</span></a>
                </li>
            </ul>
        </div>
        <div class="news">
            <div class="ntitle"><span></span>“云党课”直播间<div class="rightmore"><a href="#/yundangkelist/直播间/149">查看更多&raquo;</a></div></div>
            <div v-for="live in liveroom" v-bind:key="live.id" class="liveitem">
                <div class="live"><a :href="live.link"><img :src="live.img" width="96%"><br>{{live.title}}</a>
                </div>
            </div>
            <div style="clear:both;"></div>
        </div>
        <div class="news">
            <div class="ntitle"><span></span>获奖影片大赏<div class="rightmore"><a href="#/yundangkelist/更多/136">查看更多&raquo;</a></div></div>
            <div v-for="live2 in liveroom2" v-bind:key="live2.id" class="liveitem2">
                <div class="live2"><a :href="live2.link"><img :src="live2.img" width="96%"><br>{{live2.title}}</a>
                </div>
            </div>
            <div style="clear:both;"></div>
        </div>

        <div class="bottom">
            
        </div>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import TopMenu from "./module/topmenu"
import YNav from "./module/yundangkenav"
import Loading from "../../loading"

export default{
    name: 'YunDangke',
    data(){
        return{
            title: '云党课',
            name:"yundangke",
            sortid:'',
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            list:[],
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                },
                loop: true,
            },
            swiperSlides: [],
            liveroom:[],
            liveroom2:[],
        }
    },
    computed:{

    },
    created(){

    },
    mounted(){
        this.getData();
        this.getStatistPv();
    },
    methods:{
        showmore(){
            $(".text").css("max-height","1000px");
            $(".showmore").hide();
        },
        getData(){
            this.isLoading = true;
            jsonp(`http://byte.gxnews.com.cn/php/zgproxy.php?action=newslist&cateid=143&limit=6`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log(data);
                    this.swiperSlides = data.data.map(item =>{
                        return {
                            id:item.id,
                            link: item.tbLive?item.tbLive.liveUrl+"?apptype=tblive&appnewsId="+item.tbLive.id : item.sharelink,
                            img: item.newPicsList[0].imgurl,
                            title: item.title,
                            time: item.createTime,
                        }
                    });
                    
                }
            })

            jsonp(`http://byte.gxnews.com.cn/php/zgproxy.php?action=newslist&cateid=149&limit=3`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log(data);
                    this.liveroom = data.data.map(item =>{
                        return {
                            id:item.id,
                            link: item.tbLive?item.tbLive.liveUrl+"?apptype=tblive&appnewsId="+item.tbLive.id : item.sharelink,
                            img: item.newPicsList[0].imgurl,
                            title: item.title,
                            time: item.createTime,
                        }
                    });
                    
                }
            })

            jsonp(`http://byte.gxnews.com.cn/php/zgproxy.php?action=newslist&cateid=136&limit=4`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log(data);
                    this.liveroom2 = data.data.map(item =>{
                        return {
                            id:item.id,
                            link: item.tbLive?item.tbLive.liveUrl+"?apptype=tblive&appnewsId="+item.tbLive.id : item.sharelink,
                            img: item.newPicsList[0].imgurl,
                            title: item.title,
                            time: item.createTime,
                        }
                    });
                    
                }
            })
            
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fyundangke%2f${this.name}&sid=${this.sortid}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        TopMenu,
        YNav,
        Loading
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        margin-top: 16px;
        .swiper{
            img{
                width: 100%;
            }
        }
        .swiper-title{
            font-size: 14px;
        }
        .s_banner{
            margin-bottom: 0.35rem;
            img{
                width: 100%;
            }
        }
        .foreword{
            .text{
                padding: 0.2rem;
                font-size: 14px;
                max-height: 2.2rem;
                overflow: hidden;
                p{
                    padding: 0.1rem 0;
                    text-indent: 2em;
                    line-height: 1.8em;
                }
            }
            .showmore{
                text-align: center;
                padding-top: 6px;
                span{
                    background-color: #e8e8e8;
                    padding: 6px 80px;
                    border-radius: 10px;
                }
            }
        }
        .page_ad{
            margin:0 auto;
            width: 96%;
        }
        .news{
            padding: 12px 8px;
            .ntitle{
                font-size: 22px;
                font-weight: bold;
                padding-bottom: 12px;
                span{
                    width: 6px;
                    background-color: #fc4a4a;
                    color: #fc4a4a;
                    padding: 0 3px;
                    margin-right: 8px;
                    border-radius: 3px;
                }
                .rightmore{
                    float: right;
                    color: #b3b8b1;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 36px;
                    a{
                        color: #b3b8b1;
                    }
                }
            }
            ul {
                li{
                    font-size: 14px;
                    line-height: 22px;
                    border-bottom: 1px solid #ccc;
                    padding: 8px 0;
                    span{
                        color: #7f8180;
                    }
                    a{
                        color: #1c1c1c;
                    }
                }
            }
        }
        .liveitem{
            display: flex;
            width: 50%;
            float: left;
            margin:0;

            a{
                color: #1c1c1c;
                font-size: 14px;
            }
            .live{
                text-align: center;
                width: 100%;
                margin: 0 auto;
                padding-bottom: 12px;
            }
        }
        .liveitem:nth-child(2){
            width: 100%;
        }
        .liveitem2{
            display: flex;
            width: 50%;
            float: left;
            margin:0;
            a{
                color: #1c1c1c;
                font-size: 14px;
            }
            .live2{
                text-align: center;
                margin: 0 auto;
                padding-bottom: 12px;
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
        .bottom{
            padding-bottom: 2.5rem;
        }
    }             
</style>   